import { cn } from "../../utils/helpers";

export interface AvatarProps {
    /* default label without images */
    label?: string;
    /** Function to call when avatar is clicked */
    onClick?: () => void;
    /** optional additional styling */
    className?: string;
}

export default function Avatar({ label, onClick, className }: AvatarProps) {
    return (
        <button
            className={cn(
                "outline-none bg-secondary-light cursor-pointer w-32 h-32 rounded-full border-1.5 border-primary text-[1.28rem]",
                className
            )}
            onClick={onClick}
            aria-label="avatar"
        >
            <span role="presentation">{label}</span>
        </button>
    );
}
